class DatosFormulario {
    constructor() {

        let importe = this.getRadioValue('importe_radio');
        if (parseFloat(importe)===-1) {
            importe = document.querySelector('input[name="importe"]').value;
        }
        this.datos = {
            tipo_usuario: document.querySelector('input[name="tipo_usuario"]:checked').value,
            nombre: document.querySelector('input[name="nombre"]').value,
            apellidos: document.querySelector('input[name="apellidos"]').value,
            email: document.querySelector('input[name="email"]').value,
            telefono: document.querySelector('input[name="telefono"]').value,
            nombre_empresa: document.querySelector('input[name="nombre_empresa"]').value,
            sexo: this.getRadioValue('sexo'),
            recibo: this.getRadioValue('recibo'),
            cif: document.querySelector('input[name="cif"]').value,
            direccion: document.querySelector('input[name="direccion"]').value,
            provincia: this.getSelectValue('provincia'),
            pais: this.getSelectValue('pais'),
            localidad: document.querySelector('input[name="localidad"]').value,
            codigo_postal: document.querySelector('input[name="codigo_postal"]').value,
            newsletter: this.getRadioValue('newsletter'),
            privacidad: this.getRadioValue('privacidad'),
            importe: importe,
            concepto_donacion: document.querySelector('input[name="concepto_donacion"]').value,
            codigo_emergencia: document.querySelector('input[name="codigo_emergencia"]').value,
        }
    }

    getRadioValue(inputName) {
        let domElement = document.querySelector('input[name="' + inputName + '"]:checked'),
            value = null;
        if (domElement) {
            value = domElement.value
        }
        return value;
    }

    getSelectValue(inputName) {
        let domElement = document.querySelector('select[name="' + inputName + '"]'),
            value = null;
        if (domElement) {
            value = domElement.value
        }
        return value;
    }

    get() {
        return this.datos;
    }
}

export default DatosFormulario;